export const isPwaInstalled = (): boolean => {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  if (document.referrer.startsWith("android-app://")) {
    return true;
  } else if (true === isStandalone) {
    return true;
  }
  return false;
};
